import UserSidebar from "./Components/UserSidebar";
import React, { useState, useEffect } from "react";
import NFTMarketplace from "../artifacts/contracts/NFTMarketplace.sol/NFTMarketplace.json";
import nftmarketaddress from "../config";
import { ethers } from "ethers";
import axios from "axios";
import Web3Modal from "web3modal";
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AiOutlineLike, AiFillLike } from 'react-icons/ai';
import {TestBAlert} from './Components/TestBAlert'
const Orders = () => {
  let wAddressLocalget = JSON.parse(localStorage.getItem("wAddressLocal"));
  const [nfts, setNfts] = useState([]);
  const [selectedNft, setSelectedNft] = useState(null);
  const [loadingState, setLoadingState] = useState("not-loaded");
  const [showModal, setShowModal] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  function formatAddress(address) {
    return `${address.slice(0, 3)}...${address.slice(-4)}`;
  }
  
  const handleShowModal = (nft) => {
    setSelectedNft(nft);
    setShowModal(true);
  };
  const handleCloseModal = () => setShowModal(false);
  useEffect(() => {
    loadNFTs();
    
  }, []);
  function ncard(val) {
    const isLikedByCurrentUser = val.likes.includes(wAddressLocalget);
    return (
      <>
        <tr>
          <td>{val.tokenId.slice(-3)} </td>
          <td className="mint-image" width={1}>
            <img
              src={val.image}
              alt=""
              className="rounded fluid"
              height={40}
              onClick={() => viewNft(val)}
            />
          </td>
          <td>{val.name}</td>
          <td>{val.price} MATIC</td>
          {/* <td>{formatAddress(val.owner)}</td> */}
          <td>{formatAddress(val.seller)}</td>
          <td>
          {val.totalLikes}{" "}
          {isLikedByCurrentUser ? (
            <span
              onClick={() => likeNft(val)}
              style={{ cursor: "pointer" }}
            >
              <AiFillLike />
            </span>
          ) : (
            <span
              onClick={() => likeNft(val)}
              style={{ cursor: "pointer" }}
            >
              <AiOutlineLike />
            </span>
          )}
        </td>
          {/* <td>{val.description} </td> */}
          <td>
            <button
              type="Button"
              className="btn btn-outline-success me-2 mt-2"
              onClick={() => buyNft(val)}
            >
              Buy
            </button>
            <button
              type="Button"
              className="btn btn-outline-info me-2 mt-2"
              onClick={() => viewNft(val)}
            >
              View
            </button>
          </td>

        </tr>

        {/* <Modal show={showModal} onHide={handleCloseModal}>
  <Modal.Body>
    {selectedNft && (
      <img src={selectedNft.image} alt="" className="img-fluid" />
    )}
  </Modal.Body>
</Modal> */}

        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>NFT Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            
            {selectedNft && (
              <>
                <img src={selectedNft.image} alt="" className="img-fluid" />
                <h5>Name: {selectedNft.name}</h5>
                <p>Seller: {selectedNft.seller}</p>
                <p>Owner: {selectedNft.owner}</p>
                <p>Description: {selectedNft.description}</p>
                <p>Likes: {selectedNft.likes}</p>

              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button
              type="Button"
              className="btn btn-outline-info me-2 mt-2"
              onClick={handleCloseModal}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

      </>
    );
  }
  async function loadNFTs() {
    const response = await axios.get("https://mint-blocks-api-production.up.railway.app/api/nftsApproved");

    const items = response.data.map((item) => ({
      price: item.price,
      tokenId: item.tokenId.toString(),
      seller: item.sellerAddress,
      owner: item.ownerAddress,
      image: item.fileUrl,
      name: item.name,
      description: item.description,
      isApproved: item.isApproved,
      // productLikes: item.productLikes,
      totalLikes: item.totalLikes,
      likes: item.likes || [],
    }));
    setNfts(items);
    setLoadingState("loaded");
  }

  async function viewNft(nft) {
    try {
      const response = await axios.get(
        `https://mint-blocks-api-production.up.railway.app/api/nftsByTokenId/${Number(nft.tokenId)}`
      );

      // Get the NFT details from the response
      const nftDetails = response.data;

      // Show the details in a popup
      setShowModal(true);
      setSelectedNft({
        image: nftDetails.fileUrl,
        name: nftDetails.name,
        seller: nftDetails.sellerAddress,
        owner: nftDetails.ownerAddress,
        description: nftDetails.description,
        likes: nftDetails.totalLikes,
      });
    } catch (error) {
      console.error(error);
      toast.error("An error occured while viewing NFT, try again.")
    }
  }
  async function likeNft(nft) {
    console.log("Like", nft.tokenId, JSON.stringify(wAddressLocalget))
    try {
      const response = await axios.post("https://mint-blocks-api-production.up.railway.app/api/like", {
        tokenId: nft.tokenId,
        sellerAddress: JSON.stringify(wAddressLocalget)
      });
      const { likes } = response.data;
      console.log("Likes:", likes);
      setIsLiked(!isLiked);
      loadNFTs();
      
    } catch (error) {
      console.error(error);
      toast.error("An error occured while liking this NFT, please try again later")
    }
  }
  async function buyNft(nft) {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    const contract = new ethers.Contract(nftmarketaddress, NFTMarketplace.abi, signer);

    try {
      toast.info("Connecting to MetaMask, please wait")
      const price = ethers.utils.parseUnits(nft.price.toString(), "ether");
      const transaction = await contract.createMarketSale(nft.tokenId, {
        value: price,
      });
      toast.info("Your transaction is processing please wait")
      await transaction.wait();
      toast.success("You have successfully purchased an NFT, go to Assets page to view")
      // Query the database to find the NFT with the matching tokenId
      const response = await axios.get(`https://mint-blocks-api-production.up.railway.app/api/nftsByTokenId/${Number(nft.tokenId)}`);
      console.log(response.data)
      // Send the NFT data to the assets collection API
      const assetData = {
        tokenId: response.data.tokenId,
        name: response.data.name,
        description: response.data.description,
        fileUrl: response.data.fileUrl,
        price: response.data.price,
        ownerAddress: response.data.ownerAddress,
        sellerAddress: response.data.sellerAddress,
        totalLikes: response.data.totalLikes
      };
      const response2 = await axios.post('https://mint-blocks-api-production.up.railway.app/assets', assetData);
      console.log('Response from the server:', response2.data);

      // Delete the NFT from the database
      await axios.delete(`https://mint-blocks-api-production.up.railway.app/api/nftsDelTokenId/${nft.tokenId}`);

      // Reload the list of NFTs after deletion
      loadNFTs();
    } catch (error) {
      console.error(error);
      toast.error("Make sure you have enough balance or try again later")
    }
  }







  if (wAddressLocalget !== null) {
    return (
      <div className="container user-dashboard-page">
        <div className="sticky-sidebar user-sidebar">
          <UserSidebar />
        </div>
        <div className=" user-main container">
        <TestBAlert/>
          <div className="heading">
            <h3 className="mt-3">All Created NFTs</h3>
            <p>All created NFTs are listed below</p>
          </div>
          {nfts.length === 0 ? (
            <p>No NFTs to display.</p>
          ) : (
            <table className="table table-container">
              <thead>
                <tr className="table-light">
                  <th scope="col">ID</th>
                  <th scope="col">Image</th>
                  <th scope="col">Title</th>
                  <th scope="col">Price</th>

                  {/* <th scope="col">Owner</th> */}
                  <th scope="col">Seller</th>
                  <th scope="col">Likes</th>

                  {/* <th scope="col">Description</th> */}
                  <th scope="col">Action</th>

                </tr>
              </thead>
              <tbody>{nfts.map(ncard)}</tbody>
            </table>
            
          )}
         
         
        </div>
        <ToastContainer position="top-right" />
      </div>
    );
  } else {
    console.log("NO");
    return (
      <div className="container">
        <p>
          You don't have permissions to access this page. Please connect your
          wallet.
        </p>
      </div>
    );
  }
};
export default Orders;
